import { createRoot } from "react-dom/client";

// React 18 replaced ReactDOM.render / ReactDOM.unmountComponentAtNode (both
// removed outright in React 19) with the createRoot API. We track the root
// created for each mounted node so unmountComponents() can tear it down, and so
// re-mounting an already-mounted node reuses its root instead of warning about
// (or leaking) a second root on the same container.
const roots = new WeakMap();

const GreenArrowReactMounter = {
  mountComponents: () => {
    var nodes = $("[data-react-class]", document);
    for (var i = 0; i < nodes.length; ++i) {
      var node = nodes[i];
      var className = node.getAttribute("data-react-class");
      var constructor = window[className];
      var propsJson = node.getAttribute("data-react-props");
      var props = propsJson && JSON.parse(propsJson);

      if (typeof constructor === "undefined") {
        var message = "Cannot find component: '" + className + "'";
        if (console && console.log) {
          console.log(
            "%c[react-rails] %c" + message + " for element",
            "font-weight: bold",
            "",
            node,
          );
        }
        var error = new Error(
          message +
            ". Make sure your component is globally available to render.",
        );
        throw error;
      } else {
        var root = roots.get(node);
        if (!root) {
          root = createRoot(node);
          roots.set(node, root);
        }
        root.render(React.createElement(constructor, props));
      }
    }
  },

  unmountComponents: () => {
    var nodes = $("[data-react-class]", document);

    for (var i = 0; i < nodes.length; ++i) {
      var node = nodes[i];
      var root = roots.get(node);

      if (root) {
        root.unmount();
        roots.delete(node);
      }
    }
  },
};

export default GreenArrowReactMounter;
